import { makeStyles } from '@material-ui/core'


const ModalClientsTheme = makeStyles((theme) => ({
    botoes: {
        display: "flex",
        justifyContent: "flex-end",
        marginTop: "10px",
    }
}));

export default ModalClientsTheme;